import type { ModuleNav } from '@saas/ui';

export const assetNav: ModuleNav = {
  module: 'asset',
  items: [],
  admin: [{ label: '資産台帳', to: '/asset-register', icon: 'inventory', permission: 'asset.item.read', description: '端末・プリンター・カメラ・家具の購入と貸与' }],
};
